import { Filters } from '@/lib/search-helpers';
import { SortType } from './types';

export const variantsList: Array<Filters> = [
  'color',
  'condition',
  'storage',
  'connectivity',
  'simSlot',
  'ram',
  'brand',
  'categories',
  'screenSize',
  'cpu',
  'serviceProviders',
  'dealTypes',
  'watchBandColor',
  'watchCaseColor',
  'watchBandType',
  'watchBandMaterial',
  'watchFaceSize',
  'watchCaseMaterial',
  'batteryHealth',
  'model',
  'releaseYear',
];

export const sortList: Array<SortType> = [
  { name: 'Best Selling', value: 'best-selling' },
  { name: 'Price (Low to High)', value: 'price-asc' },
  { name: 'Price (High to Low)', value: 'price-desc' },
  { name: 'Latest Release', value: 'latest-release' },
];
